import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const TOKEN_KEY = "hr_access_token";
const SESSION_KEY = "hr_session_token";
const GRANT_KEY = "hr_gallery_grants";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const getSessionToken = () => localStorage.getItem(SESSION_KEY);

export function setTokens({ access_token, session_token }) {
  if (access_token) localStorage.setItem(TOKEN_KEY, access_token);
  if (session_token) localStorage.setItem(SESSION_KEY, session_token);
}

export function clearTokens() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(SESSION_KEY);
}

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = getToken();
  const session = getSessionToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  if (session) config.headers["X-Session-Token"] = session;
  const match = /\/events\/([^/?#]+)/.exec(config.url || "");
  const grant = match ? grantFor(decodeURIComponent(match[1])) : null;
  if (grant) config.headers["X-Gallery-Access"] = grant;
  return config;
});

export function readGrants() {
  try {
    return JSON.parse(localStorage.getItem(GRANT_KEY) || "{}");
  } catch {
    return {};
  }
}

export function saveGrant(slug, token) {
  const grants = readGrants();
  grants[slug] = token;
  localStorage.setItem(GRANT_KEY, JSON.stringify(grants));
}

export function grantFor(slug) {
  return readGrants()[slug] || null;
}

export function galleryHeaders(slug) {
  const token = grantFor(slug);
  return token ? { "X-Gallery-Access": token } : {};
}

export function mediaUrl(media, variant = "web", slug = null) {
  const params = new URLSearchParams({ variant });
  const version = media.derivative_v || media.edited_at;
  if (version) params.set("v", String(version));
  const grant = slug ? grantFor(slug) : null;
  if (grant) params.set("gt", grant);
  const token = getToken();
  if (token) params.set("auth", token);
  const session = getSessionToken();
  if (session) params.set("session", session);
  return `${API}/media/${media.id}/file?${params.toString()}`;
}

export function apiError(detail) {
  if (detail == null) return "Ocurrió un error. Intente de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
